'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles = require('@material-ui/styles');

var styleElId = 'jss-server-side';

function renderHead(ctx) {
  var jssStyles = ctx.sheets.toString(); // outputs <style id="jss-server-side">${css}</style>

  return React__default.createElement('style', {
    id: styleElId
  }, jssStyles);
}

function didMount(ctx) {
  var jssStyles = document.getElementById(styleElId);

  if (jssStyles && jssStyles.parentNode) {
    jssStyles.parentNode.removeChild(jssStyles);
  }
}

function createContext(theme) {
  var sheets = new styles.ServerStyleSheets();
  return {
    sheets: sheets,
    theme: theme
  };
}

function Provider(props) {
  var _useContext = React.useContext(props.ctx),
      theme = _useContext.theme,
      sheets = _useContext.sheets;

  return sheets.collect(React__default.createElement(styles.ThemeProvider, {
    theme: theme
  }, props.children));
}

function setup(_ref) {
  var theme = _ref.theme;

  var createServerContext = function createServerContext() {
    return createContext(theme);
  };

  return {
    didMount: didMount,
    Provider: Provider,
    createServerContext: createServerContext,
    createClientContext: createServerContext,
    renderHead: renderHead
  };
}

module.exports = {
  setup: setup
};
